import { render } from "./StoriesVue.vue?vue&type=template&id=ff8dfd64&scoped=true"
import script from "./StoriesVue.vue?vue&type=script&lang=js"
export * from "./StoriesVue.vue?vue&type=script&lang=js"

import "./StoriesVue.vue?vue&type=style&index=0&id=ff8dfd64&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff8dfd64"]])

export default __exports__